import React from "react";

export const handleUrlOnClick = (
  callback: (event: React.MouseEvent) => void | boolean | undefined
) => {
  return (event: React.MouseEvent) => {
    if (event.metaKey || event.ctrlKey || event.button === 1) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    return callback(event);
  };
};
